export default __webpack_public_path__ + "static/media/background2.46eb8f93.svg";